import styled from '@emotion/styled';

export const ToggleSwitch = styled.div``;

export const Label = styled.label``;
